import { render, staticRenderFns } from "./tna-report-detail.vue?vue&type=template&id=362e4914&scoped=true"
import script from "./tna-report-detail.vue?vue&type=script&lang=js"
export * from "./tna-report-detail.vue?vue&type=script&lang=js"
import style0 from "./tna-report-detail.vue?vue&type=style&index=0&id=362e4914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362e4914",
  null
  
)

export default component.exports